<template>
    <v-container>
        <!-- Titulo y texto -->
        <div style="background-color: rgb(230, 233, 242); padding-left: 20px; padding-right: 20px; padding-bottom: 15px;">
            <h2 style="font-size: 2.5rem; color: rgb(0, 30, 67)">Buscador</h2>
            <v-row>
                <v-col cols="12" md="12" lg="12">
                    <p>
                        <b style="color: rgb(0, 30, 67)">¿Cómo usar el buscador?</b><br>
                        Con el buscador de <b style="color: rgb(0, 30, 67)">IDmaderas</b> podrás seleccionar las características clave de la madera que se pretende identificar, para ello:<br>
                        
                        <ol>1. Ubica la sección transversal de la madera.</ol>
                        <ol>2. Con la ayuda de una cuchilla realiza un corte limpio en la sección transversal de la madera.</ol>
                        <ol>3. Usa una lupa de aumento (mínimo 10x) para examinar las características anatómicas de la madera en detalle.</ol>
                        <ol>4. Selecciona las características de la madera (textura, poros, parénquima e inclusiones) usando los filtros.</ol>
                        <ol>5. Ubica la sección tangencial de la madera e identifica el tipo de radios.</ol>
                        <div style="background-color: rgb(189, 188, 188); padding: 10px 10px 10px 10px;">
                            Para un mejor entendimiento de los términos técnicos, consulta el <router-link :to="{ name: 'glosario' }" style="color: rgb(0, 30, 67); text-decoration: none;"><b>GLOSARIO</b></router-link>. 
                            Allí encontrarás definiciones claras que te ayudarán a identificar y comprender las características anatómicas de la madera.
                        </div>
                    </p>
                </v-col>
            </v-row>
        </div>
        <br>
        <!--TABLA DE DATOS-->
        <div>
            <v-row>
                <v-col cols="12" lg="12">
                    <v-text-field v-model="search" label="Buscar por nombre (común, cientifico, comercial)" outlined dense hide-details>
                        <template v-slot:append>
                            <div style="color: white; background-color: rgb(0, 124, 186); height: 100%; margin-right: -12px; margin-top: -7px; padding: 10px">
                                <v-icon style="color: white;">search</v-icon>Buscador
                            </div>
                        </template>
                    </v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" lg="2">
                    <v-select v-model="FiltroPoros" :items="optionsPoros" item-text="titulo" item-value="oid" label="Filtrar por Poros" outlined dense multiple :menu-props="{ open: true, openOnClick: false }"></v-select>
                </v-col>
                <v-col cols="12" lg="2">
                    <v-select v-model="FiltroParenquima" :items="optionsParenquimas" item-text="titulo" item-value="oid" label="Filtrar por Parénquima" outlined dense multiple></v-select>
                </v-col>
                <v-col cols="12" lg="2">
                    <v-select v-model="FiltroRadios" :items="optionsRadios" item-text="titulo" item-value="oid" label="Filtrar por Radios" outlined dense multiple></v-select>
                </v-col>
                <v-col cols="12" lg="2">
                    <v-select v-model="FiltroTextura" :items="optionsTexturas" item-text="titulo" item-value="oid" label="Filtrar por Textura" outlined dense multiple></v-select>
                </v-col>
                <v-col cols="12" lg="2">
                    <v-select v-model="FiltroInclusiones" :items="optionsInclusiones" item-text="titulo" item-value="oid" label="Filtrar por Inclusiones" outlined dense multiple></v-select>
                </v-col>
                <v-col cols="12" lg="auto" class="d-flex align-center">
                    <v-btn @click="limpiarFiltros" style="background-color: rgb(0, 124, 186); color: white; margin-top: -25px;">
                        Limpiar Filtros
                    </v-btn>
                </v-col>
            </v-row>
            <v-row>
                <v-col v-for="especie in filtered" :key="especie.oid" cols="12" md="3">
                    <v-card class="mx-auto card-hover" max-width="500" min-height="225" @click="mostrar(especie.oid)">   
                        <v-carousel :show-arrows="false" cycle height="180" hide-delimiters>
                            <v-carousel-item v-for="(image, index) in especie.images" :key="index">
                                <v-img  class="align-end text-white" height="100%" :src="image.src" :alt="image.alt" :style="{ 'object-fit': 'cover' }"></v-img>
                            </v-carousel-item>
                        </v-carousel>
                        <v-card-title class="text-center" style="color: white; background-color: rgb(0, 124, 186); font-size: 13px; width: 100%; display: flex; justify-content: center; padding-top: 2px; padding-bottom: 5px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                            {{ especie.n_comun }} <svg v-if="(especie.estado === 1)" :width="24" :height="24" viewBox="0 0 24 24"><path :d="mdiLeaf" fill="red"/></svg>
                        </v-card-title>
                        <v-card-subtitle class="text-center" style="color: white; background-color: rgb(0, 124, 186); font-size: 13px; width: 100%; font-style: italic; padding-bottom: 5px;">
                            {{ especie.n_cientifico }}
                        </v-card-subtitle>
                    </v-card>
                </v-col>
            </v-row>
        </div>
        <div>
            <!-- Diálogo para ver detalle-->
            <v-dialog v-model="dialogdetail" max-width="90%">
                <v-card>
                    <v-card-title class="headline" style="position: relative;">
                        <v-icon @click="cancelarDetalle" style="position: absolute; right: 10px; cursor: pointer;">close</v-icon>
                        <v-icon @click="cancelarDetalle" right>close</v-icon>
                    </v-card-title>
                    <v-card-text>
                        <v-container grid-list-md>
                            <v-layout wrap>
                                <v-row>
                                    <!-- Nombre e Imagenes -->
                                    <v-col cols="12" md="12" lg="6">
                                        <v-flex xs12 sm12 md12 fixed>
                                        <h1 class="text-center">{{ dato.n_comun }}</h1><br>
                                        <h1 class="text-center"><em><b>{{ extractedName1 }}</b></em></h1><br>                   
                                        </v-flex>
                                        <v-flex xs12 sm12 md12>
                                            <div v-if="allImages.length > 0">
                                                <v-carousel hide-delimiters height="600px" cycle class="overlay-carousel">
                                                    <v-carousel-item v-for="(image, index) in allImages" :key="index" class="fade-transition">
                                                        <v-img :src="image.src" :alt="image.alt" aspect-ratio="1.75"></v-img>
                                                        <p style="font-size: 1.5rem; color: rgb(15, 135, 201);padding-left: 15px;"> {{ image.label }}</p>
                                                    </v-carousel-item>
                                                </v-carousel>
                                            </div>
                                            <div v-else>
                                                <p>No hay imágenes para mostrar</p>
                                            </div>
                                            <div v-if="allImagesTips.length > 0">
                                                <v-carousel hide-delimiters height="800px" cycle class="overlay-carousel">
                                                    <v-carousel-item v-for="(image, index) in allImagesTips" :key="index" class="fade-transition">
                                                        <v-img :src="image.src" :alt="image.alt" aspect-ratio="1.75"></v-img>
                                                        <p style="font-size: 1.5rem; color: rgb(15, 135, 201);padding-left: 15px;"> {{ image.label }}</p>
                                                    </v-carousel-item>
                                                </v-carousel>
                                            </div>
                                            <div v-else>
                                                <p>No hay Tips  para mostrar</p>
                                            </div>
                                        </v-flex>
                                    </v-col>
                                    <!-- Detalles de Cards -->
                                    <v-col cols="12" md="12" lg="6">
                                        <details>
                                            <summary>
                                                <p><b>Información General</b></p>
                                            </summary>
                                            <v-row>
                                                <v-col cols="12" md="6" lg="4">
                                                    <p style="padding-left: 15px;"><span class="label"><b>Nombre Común<br></b></span>{{ dato.n_comun }}</p>
                                                </v-col>
                                                <v-col cols="12" md="6" lg="4">
                                                    <p style="padding-left: 15px;"><span class="label"><b>Nombre Cientifico<br></b></span>{{ dato.n_cientifico }}</p>
                                                </v-col>
                                                <v-col cols="12" md="6" lg="4">
                                                    <p style="padding-left: 15px;"><span class="label"><b>Autor<br></b></span>{{ dato.autor }}</p>
                                                </v-col>
                                                <v-col cols="12" md="6" lg="4">
                                                    <p style="padding-left: 15px;"><span class="label"><b>Familia<br></b></span>{{ dato.familia }}</p>
                                                </v-col>
                                                <v-col cols="12" md="6" lg="4">
                                                    <p style="padding-left: 15px;"><span class="label"><b>Nombre Comercial Internacional<br></b></span>{{ dato.n_comercial }}</p>
                                                </v-col>
                                                <v-col cols="12" md="6" lg="11">
                                                    <p style="padding-left: 15px;"><span class="label"><b>Otros Nombres Comunes<br></b></span>{{ dato.n_otro }}</p>
                                                </v-col>
                                                <v-col cols="12" md="6" lg="11">
                                                    <p style="padding-left: 15px;"><span class="label"><b>Sinónimos botánicos<br></b></span>{{ dato.sinonimo }}</p>
                                                </v-col>
                                            </v-row>
                                        </details>
                                        <details>
                                            <summary>
                                                <p><b>Características</b></p>                                                
                                            </summary>                                    
                                            <v-row>                                                    
                                                <v-col cols="12" md="6" lg="6">
                                                    <p style="padding-left: 15px;"><b>Características macroscópicas</b></p>
                                                    <p style="padding-left: 15px;"><span class="label"><b>Porosidad<br></b></span>{{ dato.porosidad }}</p>
                                                    <h3 style="padding-left: 15px;">Poros</h3>
                                                        <ul style="padding-left: 10%;">
                                                            <li v-for="poro in dato.poros" :key="poro"><p>{{ poro }}</p></li>
                                                        </ul>
                                                    <h3 style="padding-left: 15px;">Parénquimas</h3>
                                                        <ul style="padding-left: 10%;">
                                                            <li v-for="parenquima in dato.parenquimas" :key="parenquima"><p>{{ parenquima }}</p></li>
                                                        </ul>
                                                    <h3 style="padding-left: 15px;">Radios</h3>
                                                        <ul style="padding-left: 10%;">
                                                            <li v-for="radio in dato.radios" :key="radio"><p>{{ radio }}</p></li>
                                                        </ul>
                                                    <h3 style="padding-left: 15px;">Inclusiones</h3>
                                                        <ul style="padding-left: 10%;">
                                                            <li v-for="inclusion in dato.inclusiones" :key="inclusion"><p>{{ inclusion }}</p></li>
                                                        </ul>
                                                </v-col>
                                                <v-col cols="12" md="6" lg="5">
                                                    <p><b>Características generales</b></p>
                                                    <h3>Texturas</h3>
                                                        <ul style="padding-left: 10%;">
                                                            <li v-for="textura in dato.texturas" :key="textura"><p>{{ textura }}</p></li>
                                                        </ul>
                                                    <p><span class="label"><b>Color<br></b></span>{{ dato.color }}</p>
                                                    <p><span class="label"><b>Olor<br></b></span>{{ dato.olor }}</p>
                                                    <p><span class="label"><b>Sabor<br></b></span>{{ dato.sabor }}</p>
                                                    <p><span class="label"><b>Veteado<br></b></span>{{ dato.veteado }}</p>
                                                </v-col>
                                            </v-row>
                                        </details>
                                        <details v-if="(dato.estado === 1)">
                                            <summary>
                                                <p><b>Estado de conservación</b></p>
                                            </summary>
                                            <v-row>
                                                <v-col cols="12" md="6" lg="3">
                                                    <p style="padding-left: 15px;"><strong>¿La especie se encuentra en algún apéndice CITE?</strong> {{ consultarAprobado('estado').texto }}</p>
                                                </v-col>
                                                <v-col cols="12" md="6" lg="8">
                                                    <p style="padding-left: 15px;"><span class="label"><b>Completar según categoría UICN o Apéndice CITE<br></b></span>{{ dato.desc_estado }}</p>
                                                </v-col>
                                            </v-row>
                                        </details>
                                        <!--<details v-if="(img_desc_tip1 != null)">
                                            <summary>
                                                <p><b>TIPs</b></p>
                                            </summary>
                                            <v-row>
                                                <v-col cols="12" md="6" lg="1">
                                                    <p><b style="padding-left: 15px;">Tip 1</b></p>
                                                </v-col>
                                                <v-col cols="12" md="6" lg="5">
                                                    <v-img :src="images_Tip1" max-width="80%" contain></v-img>
                                                </v-col>
                                                <v-col cols="12" md="6" lg="4">
                                                    <p><span class="label"><b>Descripción Tip 1:<br></b></span>{{ dato.img_desc_tip1 }}</p>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12" md="6" lg="1">
                                                    <p><b style="padding-left: 15px;">Tip 2</b></p>
                                                </v-col>
                                                <v-col cols="12" md="6" lg="5">
                                                    <v-img :src="images_Tip2" max-width="80%" contain></v-img>
                                                </v-col>
                                                <v-col cols="12" md="6" lg="4">
                                                    <p><span class="label"><b>Descripción Tip 2:<br></b></span>{{ dato.img_desc_tip2 }}</p>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12" md="6" lg="1">
                                                    <p><b style="padding-left: 15px;">Tip 3</b></p>
                                                </v-col>
                                                <v-col cols="12" md="6" lg="5">
                                                    <v-img :src="images_Tip3" max-width="80%" contain></v-img>
                                                </v-col>
                                                <v-col cols="12" md="6" lg="4">
                                                    <p><span class="label"><b>Descripción Tip 3:<br></b></span>{{ dato.img_desc_tip3 }}</p>
                                                </v-col>
                                            </v-row>
                                        </details>-->
                                    </v-col>
                                </v-row>
                            </v-layout>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn color="rgb(0, 124, 186)" text @click="cancelarDetalle">Cerrar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <!-- Dialogo para Mensaje cargando-->
            <v-dialog v-model="dialog_guardando" max-width="550px"> 
                <v-card>
                    <v-card-title class="headline">Saving.....</v-card-title>
                </v-card>
            </v-dialog>

            <!-- Mensaje de confirmación-->
            <v-snackbar v-model="guardarExitoso" color="success" top>
                Saved successfully
                <template v-slot:action="{ attrs }">
                    <v-btn color="success" text v-bind="attrs" @click="registroExitoso = false">Close</v-btn>
                </template>
            </v-snackbar>
        </div>
    </v-container>
</template>
<script>
import axios from 'axios';
import { mdiLeaf } from '@mdi/js';

export default {
    data() {
        return {
            mdiLeaf,
            datos: [],
            texturas: [],
            poros: [],
            radios: [],
            parenquimas: [],
            inclusiones: [],
            texturasxEspecie: [],
            porosxEspecie: [],
            radiosxEspecie: [],
            parenquimasxEspecie: [],
            inclusionesxEspecie: [],
            dato: {
                oid: 0,
                n_comun: '',
                n_cientifico: '',
                autor: '',
                n_opciones: '',
                n_comercial: '',
                n_otro: '',
                sinonimo: '',
                color: '',
                olor: "",
                sabor: "",
                veteado: "",
                porosidad: "",
                familia: "",
                estado: null,
                desc_estado: "",
                images: '',
                texturas: [], // nuevo campo para las texturas
                poros: [],
                radios: [],
                parenquimas: [],
                inclusiones: [],                
                Corte1: null,
            },
            search: '',            
            FiltroTextura: [],
            FiltroParenquima: [],
            FiltroPoros: [],
            FiltroRadios: [],
            FiltroInclusiones: [],
            headers: [
                //{ text: 'Actions', value: 'actions', sortable: false },
                { text: 'Nombre Común', value: 'n_comun' }, 
                { text: 'Nombre Cientifico', value: 'n_cientifico' },
                { text: 'Nombre comercial internacional', value: 'n_comercial' },
                { text: 'Otros nombres comunes', value: 'n_otro' },
                { text: 'Sinónimos botánicos', value: 'sinonimo'},
                { text: 'Color', value: 'color' },
                { text: 'Olor', value: 'olor' },
                { text: 'Sabor', value: 'sabor' },
                { text: 'Veteado', value: 'veteado' },
                { text: 'Porosidad', value: 'porosidad' },
                { text: 'Texturas', value: 'texturas' }, // Nuevo header para texturas
                { text: 'Parenquimas', value: 'parenquimas' },
                { text: 'Poros', value: 'poros' },
                { text: 'Radios', value: 'radios' },
                { text: 'Inclusiones', value: 'inclusiones' }
            ],
            dialog: false,
            formTitle: '',
            dialogdetail: false,
            showConfirmDialog: false,
            isNew: true,
            dialog_guardando: false,
            guardarExitoso: false,
            images_Corte1: [],
            images_Corte2: [],
            images_Corte3: [],
            images_Corte4: [],
            images_Corte5: [],
            images_Tip1: [],
            images_Tip2: [],
            images_Tip3: [],
            img_desc_tip1: '',
            img_desc_tip2: '',
            img_desc_tip3: '',
            allImages: [],//VARIABLE PARA ALMACENAR LAS IMAGENES
            allImagesTips: [],
            especies: [],//VARIABLE PARA LOS CARDS
            ops: [
                { valor: 1, texto: 'Sí' },
                { valor: 0, texto: 'No' },
            ],
            selectedPoros: [],
            selectedParenquimas: [],
            selectedTexturas: [],
            selectedRadios: [],
            selectedInclusiones: [],
        };  
    },
    mounted() {
        this.listar();
    },
    created() {
        this.listar();
    },
    computed: {
        filtered() {
            let filteredBySearch = this.especies.filter(dato => {
                if (dato.n_comun) {
                    return dato.n_comun.toLowerCase().includes(this.search.toLowerCase()) ||
                        dato.n_cientifico.toLowerCase().includes(this.search.toLowerCase()) ||
                        dato.n_comercial.toLowerCase().includes(this.search.toLowerCase()) ||
                        dato.n_otro.toLowerCase().includes(this.search.toLowerCase()) ||
                        dato.n_opciones.toLowerCase().includes(this.search.toLowerCase());
                } else {
                    return false;
                }
            });

            if (this.FiltroTextura.length > 0) {
                filteredBySearch = filteredBySearch.filter(dato =>
                    this.FiltroTextura.some(filtro => 
                        this.texturasxEspecie.some(txE => txE.oid_especie === dato.oid && txE.oid_textura === filtro)
                    )
                );
            }

            if (this.FiltroParenquima.length > 0) {
                filteredBySearch = filteredBySearch.filter(dato =>
                    this.FiltroParenquima.some(filtro => 
                        this.parenquimasxEspecie.some(txE => txE.oid_especie === dato.oid && txE.oid_parenquima === filtro)
                    )
                );
            }

            if (this.FiltroPoros.length > 0) {
                filteredBySearch = filteredBySearch.filter(dato =>
                    this.FiltroPoros.some(filtro => 
                        this.porosxEspecie.some(txE => txE.oid_especie === dato.oid && txE.oid_poro === filtro)
                    )
                );
            }

            if (this.FiltroRadios.length > 0) {
                filteredBySearch = filteredBySearch.filter(dato =>
                    this.FiltroRadios.some(filtro => 
                        this.radiosxEspecie.some(txE => txE.oid_especie === dato.oid && txE.oid_radio === filtro)
                    )
                );
            }

            if (this.FiltroInclusiones.length > 0) {
                filteredBySearch = filteredBySearch.filter(dato =>
                    this.FiltroInclusiones.some(filtro => 
                        this.inclusionesxEspecie.some(txE => txE.oid_especie === dato.oid && txE.oid_inclusion === filtro)
                    )
                );
            }

            return filteredBySearch;
        },
        extractedName1() {
            if (!this.dato.n_cientifico) return '';

            const parts = this.dato.n_cientifico.split(',');
            const italicizedName = `${parts[0]}`;

            return `${italicizedName}`;
        },
        extractedName2() {
            if (!this.dato.n_cientifico) return '';

            const parts = this.dato.n_cientifico.split(',');
            const remainingText = parts.slice(1).join(', '); // Join remaining parts

            return `${remainingText}`;
        },
        
        optionsTexturas() {
            return [
                //{ oid: null, titulo: 'Todos' }, // Opción por defecto "Todos"
                ...this.texturas // Agregar las texturas obtenidas de la base de datos
            ];
        },
        optionsParenquimas() {
            return [
                //{ oid: null, titulo: 'Todos' }, // Opción por defecto "Todos"
                ...this.parenquimas // Agregar las parenquimas obtenidas de la base de datos
            ];
        },
        optionsPoros() {
            return [
                //{ oid: null, titulo: 'Todos' }, // Opción por defecto "Todos"
                ...this.poros // Agregar las poros obtenidas de la base de datos
            ];
        },
        optionsRadios() {
            return [
                //{ oid: null, titulo: 'Todos' }, // Opción por defecto "Todos"
                ...this.radios // Agregar las radios obtenidas de la base de datos
            ];
        },
        optionsInclusiones() {
            return [
                //{ oid: null, titulo: 'Todos' }, // Opción por defecto "Todos"
                ...this.inclusiones // Agregar las inclusiones obtenidas de la base de datos
            ];
        },
    },
    methods: {
        // Obtener la lista de Especies
        async listar() {
            try {
                const response = await axios.get('api/Especies/Listar');
                const responseParenquima = await axios.get('api/Parenquimas/Listar');
                const responseTextura = await axios.get('api/Texturas/Listar');
                const responsePoros = await axios.get('api/Poros/Listar');
                const responseRadios = await axios.get('api/Radios/Listar');
                const responseInclusiones = await axios.get('api/Inclusiones/Listar');
                const responseTexturaxEspecie = await axios.get('api/Especies/LisTexturaxEspecie');
                const responseParenquimasxEspecie = await axios.get('api/Especies/LisParenquimasxEspecie');
                const responsePorosxEspecie = await axios.get('api/Especies/LisPorosxEspecie');
                const responseRadiosxEspecie = await axios.get('api/Especies/LisRadiosxEspecie');
                const responseInclusionesxEspecie = await axios.get('api/Especies/LisInclusionesxEspecie');

                this.datos = response.data;
                this.parenquimas = responseParenquima.data;
                this.texturas = responseTextura.data;
                this.poros = responsePoros.data;
                this.radios = responseRadios.data;
                this.inclusiones = responseInclusiones.data;
                this.texturasxEspecie = responseTexturaxEspecie.data;
                this.parenquimasxEspecie = responseParenquimasxEspecie.data;
                this.porosxEspecie = responsePorosxEspecie.data;
                this.radiosxEspecie = responseRadiosxEspecie.data;
                this.inclusionesxEspecie = responseInclusionesxEspecie.data;
                
                const especiesData = response.data;

                // Iterar sobre cada especie para obtener sus imágenes
                for (let especie of especiesData) {
                    const responseImg = await axios.get(`api/BodegaImgs/ListarImagenes/${especie.oid}`);
                    especie.images = responseImg.data.map(image => ({
                        //src: `https://localhost:7027/api/BodegaImgs/MostrarImg/${especie.n_comun}/${image.nombre}`,
                        src: `https://testidmaderasback.rocol.org/api/BodegaImgs/MostrarImg/${especie.n_comun}/${image.nombre}`,
                        alt: image.nombre
                    }));
                }

                this.especies = especiesData;

            } catch (error) {
                console.error(error);
            }
        },
        isSelected(oid) {
            return this.FiltroPoros.includes(oid);
        },
        // Limpiar filtros
        limpiarFiltros() {
            this.FiltroPoros = [];
            this.FiltroParenquima = [];
            this.FiltroRadios = [];
            this.FiltroTextura = [];
            this.FiltroInclusiones = [];
            this.search = ''; // Limpiar el campo de búsqueda también, si deseas
        },
        // Alternar el estado de selección de un filtro
        toggleFiltroPoros(oid) {
            const index = this.FiltroPoros.indexOf(oid);
            if (index !== -1) {
            // Si ya está seleccionado, lo eliminamos del array
            this.FiltroPoros.splice(index, 1);
            } else {
            // Si no está seleccionado, lo agregamos al array
            this.FiltroPoros.push(oid);
            }
        },
        extractedName3() {
            if (!this.dato.n_cientifico) return '';

            // Dividir la cadena por las comas y añadir <br> después de cada coma
            const italicizedName = this.dato.n_cientifico.split(',').join(',<br>');

            return italicizedName;
        },
        // Mostrar detalles de un ESPECIE
        async mostrar(id) {            
            try {
                const response = await axios.get(`api/Especies/Mostrar/${id}`);
                this.dato = response.data;
                const nombreComun = this.dato.n_comun;

                const responseImg = await axios.get(`api/BodegaImgs/ListarImagenes/${id}`);

                // Initialize images_Corte arrays
                this.images_Tip1 = [];
                this.images_Tip2 = [];
                this.images_Tip3 = [];

                /*
                const images_Tip1  = responseImg.data
                        .filter(image => image.tip === 1)
                        .map(image => `https://localhost:7027/api/BodegaImgs/MostrarImg/${nombreComun}/${image.nombre}`);
                        //.map(image => `https://testidmaderasback.rocol.org/api/BodegaImgs/MostrarImg/${nombreComun}/${image.nombre}`);
                this.images_Tip1 = images_Tip1.length > 0 ? images_Tip1[0] : '';                

                const images_Tip2  = responseImg.data
                        .filter(image => image.tip === 2)
                        .map(image => `https://localhost:7027/api/BodegaImgs/MostrarImg/${nombreComun}/${image.nombre}`);
                        //.map(image => `https://testidmaderasback.rocol.org/api/BodegaImgs/MostrarImg/${nombreComun}/${image.nombre}`);
                this.images_Tip2 = images_Tip2.length > 0 ? images_Tip2[0] : '';
                const images_Tip3  = responseImg.data
                        .filter(image => image.tip === 3)
                        .map(image => `https://localhost:7027/api/BodegaImgs/MostrarImg/${nombreComun}/${image.nombre}`);
                        //.map(image => `https://testidmaderasback.rocol.org/api/BodegaImgs/MostrarImg/${nombreComun}/${image.nombre}`);
                this.images_Tip3 = images_Tip3.length > 0 ? images_Tip3[0] : '';*/

                const img_desc_tip1 = responseImg.data.filter(image => image.tip === 1).map(image => image.obs);
                this.img_desc_tip1 = img_desc_tip1.length > 0 ? img_desc_tip1[0] : '';
                const img_desc_tip2 = responseImg.data.filter(image => image.tip === 2).map(image => image.obs);
                this.img_desc_tip2 = img_desc_tip2.length > 0 ? img_desc_tip2[0] : '';
                const img_desc_tip3 = responseImg.data.filter(image => image.tip === 3).map(image => image.obs);
                this.img_desc_tip3 = img_desc_tip3.length > 0 ? img_desc_tip3[0] : '';

                if (responseImg.data && responseImg.data.length > 0) {
                    this.images_Tip1 = responseImg.data
                        .filter(image => image.tipo_corte === 6 && image.tip === 1)
                        .map(image => ({
                            //src: `https://localhost:7027/api/BodegaImgs/MostrarImg/${nombreComun}/${image.nombre}`,
                            src: `https://testidmaderasback.rocol.org/api/BodegaImgs/MostrarImg/${nombreComun}/${encodeURIComponent(image.nombre)}`,
                            alt: image.nombre,
                            label: this.img_desc_tip1
                        }));

                    this.images_Tip2 = responseImg.data
                        .filter(image => image.tipo_corte === 6 && image.tip === 2)
                        .map(image => ({
                            //src: `https://localhost:7027/api/BodegaImgs/MostrarImg/${nombreComun}/${image.nombre}`,
                            src: `https://testidmaderasback.rocol.org/api/BodegaImgs/MostrarImg/${nombreComun}/${encodeURIComponent(image.nombre)}`,
                            alt: image.nombre,
                            label: this.img_desc_tip2
                        }));

                    this.images_Tip3 = responseImg.data
                        .filter(image => image.tipo_corte === 6 && image.tip === 3)
                        .map(image => ({
                            //src: `https://localhost:7027/api/BodegaImgs/MostrarImg/${nombreComun}/${image.nombre}`,
                            src: `https://testidmaderasback.rocol.org/api/BodegaImgs/MostrarImg/${nombreComun}/${encodeURIComponent(image.nombre)}`,
                            alt: image.nombre,
                            label: this.img_desc_tip3
                        }));
                }

                // Initialize images_Corte arrays
                this.images_Corte1 = [];
                this.images_Corte2 = [];
                this.images_Corte3 = [];
                this.images_Corte4 = [];
                this.images_Corte5 = [];

                if (responseImg.data && responseImg.data.length > 0) {
                    this.images_Corte1 = responseImg.data
                        .filter(image => image.tipo_corte === 1)
                        .map(image => ({
                            //src: `https://localhost:7027/api/BodegaImgs/MostrarImg/${nombreComun}/${encodeURIComponent(image.nombre)}`,
                            src: `https://testidmaderasback.rocol.org/api/BodegaImgs/MostrarImg/${nombreComun}/${encodeURIComponent(image.nombre)}`,
                            alt: image.nombre,
                            label: this.getImageLabel(image.tipo_corte)
                        }));

                    this.images_Corte2 = responseImg.data
                        .filter(image => image.tipo_corte === 2)
                        .map(image => ({
                            //src: `https://localhost:7027/api/BodegaImgs/MostrarImg/${nombreComun}/${encodeURIComponent(image.nombre)}`,
                            src: `https://testidmaderasback.rocol.org/api/BodegaImgs/MostrarImg/${nombreComun}/${encodeURIComponent(image.nombre)}`,
                            alt: image.nombre,
                            label: this.getImageLabel(image.tipo_corte)
                        }));

                    this.images_Corte3 = responseImg.data
                        .filter(image => image.tipo_corte === 3)
                        .map(image => ({
                            //src: `https://localhost:7027/api/BodegaImgs/MostrarImg/${nombreComun}/${encodeURIComponent(image.nombre)}`,
                            src: `https://testidmaderasback.rocol.org/api/BodegaImgs/MostrarImg/${nombreComun}/${encodeURIComponent(image.nombre)}`,
                            alt: image.nombre,
                            label: this.getImageLabel(image.tipo_corte)
                        }));

                    this.images_Corte4 = responseImg.data
                        .filter(image => image.tipo_corte === 4)
                        .map(image => ({
                            //src: `https://localhost:7027/api/BodegaImgs/MostrarImg/${nombreComun}/${encodeURIComponent(image.nombre)}`,
                            src: `https://testidmaderasback.rocol.org/api/BodegaImgs/MostrarImg/${nombreComun}/${encodeURIComponent(image.nombre)}`,
                            alt: image.nombre,
                            label: this.getImageLabel(image.tipo_corte)
                        }));

                    this.images_Corte5 = responseImg.data
                        .filter(image => image.tipo_corte === 5)
                        .map(image => ({
                            //src: `https://localhost:7027/api/BodegaImgs/MostrarImg/${nombreComun}/${encodeURIComponent(image.nombre)}`,
                            src: `https://testidmaderasback.rocol.org/api/BodegaImgs/MostrarImg/${nombreComun}/${encodeURIComponent(image.nombre)}`,
                            alt: image.nombre,
                            label: this.getImageLabel(image.tipo_corte)
                        }));
                }

                // Concatenate the image arrays in the desired order
                this.allImages = [
                    ...this.images_Corte1,
                    ...this.images_Corte2,
                    ...this.images_Corte3,
                    ...this.images_Corte4,
                    ...this.images_Corte5
                ];

                // Concatenate the image arrays in the desired order
                this.allImagesTips = [
                    ...this.images_Tip1,
                    ...this.images_Tip2,
                    ...this.images_Tip3,
                ];

                this.dialogdetail = true;
            } catch (error) {
                console.error(error);
            }
        },
        //FUNCION PARA ASIGNAR LAS IMAGENES AL CAROUSEL
        getImageLabel(tipoCorte) {
            switch (tipoCorte) {
                case 1:
                    return 'Corte transversal 10x';
                case 2:
                    return 'Corte transversal 20x';
                case 3:
                    return 'Corte transversal 10x o 20x (con dibujos de características claves)';
                case 4:
                    return 'Corte tangencial';
                case 5:
                    return 'Corte radial';
                case 6:
                    return 'Tips';
                default:
                    return 'Imagen';
            }
        },
        consultarAprobado(variable) {
            if (this.dato[variable] === 1) {
                return { texto: 'Si'};
            }
            return { texto: 'No'};
        },        
        // Abrir el diálogo para crear una nueva área
        nueva() {
            this.dato = { oid: 0, n_comun: "", n_cientifico: "", n_comercial: "", n_otro: "", sinonimo: "", color: "", olor: "", sabor: "", veteado: "", porosidad: ""};
            this.isNew = true;
            this.formTitle = 'Nueva Especie';
            this.dialog = true;
        },
        // Abrir el diálogo para editar un área existente
        editar(dato) {
            // Filtra y asigna las texturas asociadas a la especie actual
            const texturaIds = this.texturasxEspecie
                .filter(tex => tex.oid_especie === dato.oid)
                .map(tex => tex.oid_textura);
                
            this.dato = { 
                ...dato,
                texturas: texturaIds // Asegúrate de inicializar texturas con IDs
            };
            this.isNew = false;
            this.formTitle = 'Actualizar Especie';
            this.dialog = true;
        },
        // Guardar el área creada o actualizada
        async guardar() {
            this.dialog_guardando = true;
                try {
                    const payload = {
                        ...this.dato,
                        texturas: this.dato.texturas,
                        parenquimas: this.dato.parenquimas,
                        poros: this.dato.poros,
                        radios: this.dato.radios,
                        inclusiones: this.dato.inclusiones,
                    };
                    // Realizar la lógica para guardar o actualizar el área
                    let oid_especie;
                    if (this.isNew) {
                        // Crear el área
                        const respuestaCrear = await axios.post('api/Especies/Crear', payload);
                        oid_especie = respuestaCrear.data.oid;
                        console.log(oid_especie);
                    } else {
                        // Actualizar el área
                        await axios.put(`api/Especies/Actualizar`, payload);
                        oid_especie = this.dato.oid;
                    }

                    // Función para enviar imágenes a la API
                    const enviarImagenes = async (imagenes, tipo_corte) => {
                        if (imagenes && imagenes.length > 0) {
                            const formData = new FormData();
                            formData.append('oid_especie', oid_especie);
                            formData.append('tipo_corte', tipo_corte);
                            for (let i = 0; i < imagenes.length; i++) {
                                formData.append('Imagenes', imagenes[i]);
                            }
                            await axios.post('api/BodegaImgs/SubirImagenes', formData);
                        }
                    };
                    // Función para enviar imágenes a la API
                    const enviarImagenesTip = async (imagenes, tip) => {
                        if (imagenes && imagenes.length > 0) {
                            const formData = new FormData();
                            formData.append('oid_especie', oid_especie);
                            formData.append('tip', tip);
                            for (let i = 0; i < imagenes.length; i++) {
                                formData.append('Imagenes', imagenes[i]);
                            }
                            await axios.post('api/BodegaImgs/SubirImagenes', formData);
                        }
                    };

                    // Enviar imágenes para cada tipo de corte
                    await enviarImagenes(this.dato.Corte1, 1);
                    await enviarImagenes(this.dato.Corte2, 2);
                    await enviarImagenes(this.dato.Corte3, 3);
                    await enviarImagenes(this.dato.Corte4, 4);
                    await enviarImagenes(this.dato.Corte5, 5);

                    await enviarImagenesTip(this.dato.Tip1, 1);
                    await enviarImagenesTip(this.dato.Tip2, 2);
                    await enviarImagenesTip(this.dato.Tip3, 3);

                    // Limpiar el formulario después de guardar o actualizar
                    this.dato = { oid: 0, n_comun: '', n_cientifico: '', n_comercial: '', n_otro: '', sinonimo: '', color: '', olor: '', sabor: '', veteado: '', porosidad: '', Corte1: [], Corte2: [], Corte3: [], Corte4: [], Corte5: [], };

                    // Después de guardar exitosamente el registro:
                    this.guardarExitoso = true;
                    this.dialog = false;
                    await this.listar();
                    
                } catch (error) {
                    console.error(error);
                } finally {
                    // Independientemente de si la solicitud tuvo éxito o no, detenemos el estado de carga.
                    this.dialog_guardando = false;
                }
        },
        // Eliminar un área
        async eliminar(id) {          
            try {
                await axios.delete(`api/Especies/Eliminar/${id}`);
                this.guardarExitoso = true;
                this.listar();
                this.cancelarEliminar();
            } catch (error) {
                console.error(error);
            } 
        },

        // Confirmar eliminación de un área
        confirmarEliminar(id) {
            this.confirmItemId = id;
            this.showConfirmDialog = true;
        },
        // Cancelar eliminación
        cancelarEliminar() {
            this.confirmItemId = null;
            this.showConfirmDialog = false;
        },        
        // Cancelar Detalle
        cancelarDetalle() {
            this.dialogdetail = false;            
        },
        cerrar() {
            this.dialog = false;
        },
        validarR1(value) {
            return value ? true : 'Este campo es obligatorio para registrar la especie';
        },        
        getImageSrc(filename) {
            return require(`../assets/${filename}`);
        },
    },
    
};
</script>
<style scoped>
    .v-card {
        perspective: 1000px;
        transition: transform 0.5s;
    }

    .v-card.is-flipped {
        transform: rotateY(180deg);
    }

    .custom-h1 {
        font-size: 2.5em; /* Puedes ajustar el tamaño según tus necesidades */
        font-weight: bold; /* Otras propiedades de estilo si es necesario */
    }

    .custom-h3 {
        font-size: 1.5em; /* Puedes ajustar el tamaño según tus necesidades */  
    }
    p {
        font-family: 'Heebo', sans-serif;
        font-size: 17px;        
        line-height: 1.6em;
    }
    h1 {
        font-family: 'Heebo', sans-serif;
    }
    h2 {
        font-family: 'Heebo', sans-serif;
    }
    h3 {
        font-family: 'Heebo', sans-serif;
    }
    .p1{
        font-size: 17px; 
        color: rgb(15, 135, 201); 
        line-height: 1em;
    }
      
    details { 
        background-color: #f6f8fa;
        width: 100%;
        margin-bottom: 1rem;   
        border-radius: 8px;  
        border: 1px solid #d8e0e9;
        color: #364f6b;
        position: relative;  
        padding-top: 0px;
    }
    details[open] summary {
        border-bottom: 1px solid #aaa;
        margin-bottom: 0.5em;
    }
    details summary {  
        font-weight: 400;
        font-size: 1.25rem;
        padding: 1rem;
        cursor: pointer;
        list-style: none;
    }
    details summary::before {
        content: "▶"; /* Flecha hacia la derecha */
        font-size: 1.5rem;
        line-height: 1.5rem;
        color: #364f6b;
        position: absolute;
        left: 97%; /* Ajusta el espacio entre la flecha y el texto */
    }
    details[open] summary::before {
        content: "▼"; /* Flecha hacia abajo cuando details está abierto */
    }
    .fixed {
        position: sticky;
        top: 0;
        z-index: 1;
        background-color: white; /* Asegúrate de que el fondo sea el mismo que el contenedor */
    }
    /* CAROUSEL MAS DINAMICO */
    .overlay-carousel .v-carousel-item {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        transition: opacity 0.5s ease-in-out;
        opacity: 0;
    }

    .overlay-carousel .v-carousel-item.v-window-item--active {
        opacity: 1;
        position: absolute;
    }

    .v-carousel .v-window {
        position: relative;
        height: 100%;
    }

    .fade-transition {
        transition: opacity 0.5s ease-in-out;
    }
</style>